import React from 'react';
import i18n from 'i18n';
import PropTypes from 'prop-types';

export const BrityFooter = ({ isAdmin }) => {
  const getYear = () => {
    return new Date().getFullYear();
  };

  const PRIVACY_URL = '/employeeapp/privacy-policy';
  const onClickPrivacyPolicy = e => {
    e.preventDefault();
    const width = 820;
    const height = 860;
    const parentWindow = window.parent || window;
    let xPos = parentWindow.document.body.clientWidth / 2 - width / 2;
    xPos += parentWindow.screenLeft;
    const yPos = screen.availHeight / 2 - height / 2;

    window.open(
      `${window.location.origin}${PRIVACY_URL}`,
      '_blank',
      `width=${width}, height=${height}, left=${xPos}, top=${yPos}`,
    );
  };
  return (
    <div className="saas-footer ">
      <div className="footer-wrapper">
        <span className="lang-ko">{i18n.t('MB_T_SERVICEDESK')} +82-(2)-1661-3311</span>

        <span className="copyright">Copyright {getYear()}. SAMSUNG SDS. All rights reserved.</span>
        {isAdmin && (
          <span className="copyright">
            <a onClick={onClickPrivacyPolicy} style={{ cursor: 'pointer', fontWeight: 'bold' }}>
              {i18n.t('MB_PRIVACY_POLICY')}
            </a>
          </span>
        )}
      </div>
      <div className="footer-logo">
        <div className="logo_samsung" />
      </div>
    </div>
  );
};
BrityFooter.propTypes = {
  isAdmin: PropTypes.bool,
};
BrityFooter.defaultProps = {
  isAdmin: false,
};
export default BrityFooter;
